import { EntrepreneurAnnounce8FormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurAnnounce8FormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function EntrepreneurAnnounce8FormContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EntrepreneurAnnounce8FormComponent/>
            <Footer />
        </div>        
    )
    
}